import { createModel } from '@rematch/core';

type AttachmentsMenuState = {
  open: boolean;
  anchorEl: EventTarget | null;
};

type AttachmentTooltipState = {
  hideTooltip: boolean;
};

const toggleOpen = function handleToggleOpen(
  state: AttachmentsMenuState,
  anchorEl: EventTarget | null
): AttachmentsMenuState {
  const open = !state.open;

  return {
    ...state,
    open,
    anchorEl: open ? anchorEl : null
  };
};

const hideTooltipPopup = function handlehideTooltipPopup(
  state: AttachmentTooltipState
): AttachmentTooltipState {
  return {
    ...state,
    hideTooltip: true
  };
};

const attachmentsMenu = createModel({
  state: {
    open: false,
    anchorEl: null,
    hideTooltip: false
  },
  reducers: {
    toggleOpen,
    hideTooltipPopup
  }
});

export default attachmentsMenu;
